/**
 * p360-kit.js — bloco "Proteção 360 — Monte seu kit" da página do produto.
 * Modal em etapas: Celular -> Capa -> Película -> Câmera -> Resumo -> carrinho lateral.
 * Resultados: Section Rendering em /collections/all?view=protecao-360&section_id=protecao-360-results
 * (mesma busca da seção Proteção 360, que não é alterada), filtrando por product_type + linha
 * e refinando por data-model (metacampo custom.modelo_de_celular).
 * Na página de um produto do kit, o modelo e o produto da página já entram selecionados.
 */
(function () {
  'use strict';

  var ORDER = ['model', 'case', 'film', 'camera', 'summary'];
  var TYPES = ['case', 'film', 'camera'];
  var LABELS = { case: 'Capa', film: 'Película', camera: 'Película de câmera' };
  var MAX_PAGES = 6;
  var cache = {}; // compartilhado entre instâncias: linha|tipo -> Promise<cards>

  function money(cents) {
    var v = (cents || 0) / 100;
    try {
      return v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    } catch (e) {
      return 'R$ ' + v.toFixed(2).replace('.', ',');
    }
  }

  // Produto compatível com o celular escolhido:
  // 1) metacampo "Modelo de Celular" (data-model), comparação exata;
  // 2) sem ele: "Linha do Dispositivo" (data-linhas) + "Modelo do Dispositivo" (data-variantes),
  //    ex.: linha "iPhone 15" + "Pro" = "iPhone 15 Pro"; aparelho base = "Normal".
  function cardFits(card, model) {
    var exact = (card.getAttribute('data-model') || '').trim().toLowerCase();
    if (exact) return exact === model;
    var list = function (attr) {
      return (card.getAttribute(attr) || '').split('|').map(function (v) { return v.trim().toLowerCase(); }).filter(Boolean);
    };
    var linhas = list('data-linhas');
    var vars = list('data-variantes');
    if (!linhas.length || !vars.length) return false;
    return linhas.some(function (l) {
      if (model !== l && model.indexOf(l + ' ') !== 0) return false;
      var rest = model.slice(l.length).trim() || 'normal';
      return vars.indexOf(rest) !== -1;
    });
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function init(root) {
    if (root.__p360k) return;
    root.__p360k = true;

    var cfg;
    try {
      cfg = JSON.parse(root.querySelector('[data-p360k-config]').textContent);
    } catch (e) {
      return;
    }

    var modal = root.querySelector('[data-p360k-modal]');
    if (!modal) return;
    // O modal vai para o body: evita ancestrais com transform/overflow que quebram o position: fixed.
    // No editor de temas a seção recarrega: remove o modal antigo deste bloco antes de mover o novo.
    var owner = root.id || '';
    document.querySelectorAll('body > [data-p360k-modal][data-owner="' + owner + '"]').forEach(function (old) { old.remove(); });
    modal.setAttribute('data-owner', owner);
    document.body.appendChild(modal);

    var els = {
      body: modal.querySelector('[data-p360k-body]'),
      dots: modal.querySelectorAll('[data-step-dot]'),
      panels: modal.querySelectorAll('[data-step]'),
      bar: modal.querySelector('[data-p360k-bar]'),
      barText: modal.querySelector('[data-p360k-bar-text]'),
      barFill: modal.querySelector('[data-p360k-bar-fill]'),
      loading: modal.querySelector('[data-p360k-loading]'),
      error: modal.querySelector('[data-p360k-error]'),
      back: modal.querySelector('[data-p360k-back]'),
      skip: modal.querySelector('[data-p360k-skip]'),
      finish: modal.querySelector('[data-p360k-finish]')
    };

    var state;
    var kitId;
    var busy = false;
    var lastFocus = null;

    // ---- progresso salvo (sessionStorage, por página): o cliente sai pelo título do produto e,
    // ao voltar para esta página, o modal reabre de onde parou. Expira em 2h; limpa ao finalizar.
    var STORE_KEY = 'yv-p360k:' + location.pathname + ':' + (root.id || '');
    var STORE_TTL = 2 * 60 * 60 * 1000;

    function saveState(resume) {
      try {
        sessionStorage.setItem(STORE_KEY, JSON.stringify({
          ts: Date.now(),
          resume: !!resume,
          kitId: kitId,
          step: state.step,
          model: state.model,
          linha: state.linha,
          reached: state.reached,
          chosen: state.chosen
        }));
      } catch (e) {}
    }
    function loadState() {
      try {
        var saved = JSON.parse(sessionStorage.getItem(STORE_KEY) || 'null');
        if (!saved || Date.now() - saved.ts > STORE_TTL || ORDER.indexOf(saved.step) === -1) return null;
        return saved;
      } catch (e) {
        return null;
      }
    }
    function clearState() {
      try { sessionStorage.removeItem(STORE_KEY); } catch (e) {}
    }

    function reset() {
      state = { step: 'model', model: '', linha: '', reached: 0, chosen: { case: null, film: null, camera: null } };
      kitId = 'p360k-' + Date.now().toString(36);
    }

    // Produto da página: variante selecionada no formulário do produto no momento do clique
    function pageItem() {
      var ctx = cfg.context || {};
      var variants = ctx.variants || [];
      if (!variants.length) return null;
      var section = document.getElementById('shopify-section-' + cfg.sectionId) || document;
      var input = section.querySelector('form[action*="/cart/add"] [name="id"]');
      var id = input ? String(input.value) : '';
      var v = null;
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === id) { v = variants[i]; break; }
      }
      v = v || variants[0];
      return {
        variantId: String(v.id),
        title: ctx.title,
        variantTitle: v.title && v.title !== 'Default Title' ? v.title : '',
        cents: v.cents,
        img: v.img
      };
    }

    function chosenCount() {
      return TYPES.filter(function (t) { return state.chosen[t]; }).length;
    }

    // ---- desconto (mesma regra da seção Proteção 360) ------------------------------
    function discountInfo() {
      var d = cfg.discount || {};
      var n = chosenCount();
      var res = { pct: 0, code: '', gift: false, message: '', configured: false, progress: n / 3 };
      if (d.mode === 'tiered') {
        res.configured = d.tier2Pct > 0 || d.tier3Pct > 0;
        if (n >= 3 && d.tier3Pct > 0) {
          res.pct = d.tier3Pct; res.code = d.tier3Code;
          res.message = 'Kit completo: ' + d.tier3Pct + '% de desconto aplicado!';
        } else if (n === 2 && d.tier2Pct > 0) {
          res.pct = d.tier2Pct; res.code = d.tier2Code;
          res.message = d.tier3Pct > 0
            ? d.tier2Pct + '% de desconto! Adicione mais 1 item e ganhe ' + d.tier3Pct + '%.'
            : d.tier2Pct + '% de desconto aplicado!';
        } else if (n < 3) {
          res.message = n === 0
            ? 'Escolha 2 itens e ganhe ' + d.tier2Pct + '% de desconto.'
            : 'Escolha mais 1 item e ganhe ' + d.tier2Pct + '% de desconto.';
        }
      } else if (d.mode === 'kit') {
        res.configured = d.kitPct > 0;
        if (n >= 3) {
          res.pct = d.kitPct; res.code = d.kitCode;
          res.message = 'Kit completo: ' + d.kitPct + '% de desconto aplicado!';
        } else {
          res.message = 'Faltam ' + (3 - n) + ' item(ns) para ganhar ' + d.kitPct + '% de desconto.';
        }
      } else if (d.mode === 'films') {
        // Igual aos descontos automáticos PROTECT20%OFF / PROTECTFULL20%OFF do admin:
        // com a capa no carrinho, cada película (tela e câmera) ganha o % — 1 película = título "um", 2 = título "dois".
        var fp = d.filmsPct || 0;
        var kw = (d.filmsKeyword || '').toLowerCase();
        var hasCase = !!state.chosen.case;
        var elig = ['film', 'camera'].filter(function (t) {
          var it = state.chosen[t];
          if (!it) return false;
          var title = String(it.title || '').toLowerCase();
          return !kw || title.indexOf(kw) !== -1 ||
            (t === 'camera' && title.indexOf('protetor de lentes') !== -1);
        });
        res.configured = fp > 0;
        res.progress = ((hasCase ? 1 : 0) + elig.length) / 3;
        res.title = elig.length >= 2 ? (d.filmsTitleTwo || d.filmsTitleOne) : d.filmsTitleOne;
        res.lineOff = {};
        if (hasCase) {
          elig.forEach(function (t) { res.lineOff[t] = Math.round((state.chosen[t].cents * fp) / 100); });
        }
        var other = elig.length === 1 ? (elig[0] === 'film' ? 'camera' : 'film') : '';
        if (!hasCase) {
          res.message = elig.length
            ? 'Adicione a capa e ganhe ' + fp + '% OFF nas películas.'
            : 'Leve a capa e ganhe ' + fp + '% OFF na película e na película de câmera.';
        } else if (elig.length === 0) {
          res.message = 'Adicione a película e ganhe ' + fp + '% OFF nela.';
        } else if (elig.length === 1) {
          res.message = fp + '% OFF na ' + LABELS[elig[0]].toLowerCase() + '!' +
            (state.chosen[other] ? '' : ' Adicione a ' + LABELS[other].toLowerCase() + ' e ganhe ' + fp + '% nela também.');
        } else {
          res.message = 'Kit completo: ' + fp + '% OFF na película e na película de câmera!';
        }
      } else if (d.mode === 'gift') {
        res.configured = !!d.giftVariantId;
        if (n >= 3 && d.giftVariantId) {
          res.gift = true; res.code = d.giftCode;
          res.message = (d.giftText || 'Brinde') + ' liberado no seu kit!';
        } else {
          res.message = 'Faltam ' + (3 - n) + ' item(ns) para ganhar: ' + (d.giftText || 'brinde') + '.';
        }
      }
      return res;
    }

    function renderBar() {
      var info = discountInfo();
      var show = info.configured && state.step !== 'model';
      els.bar.hidden = !show;
      if (!show) return;
      els.barText.textContent = info.message;
      els.barFill.style.width = Math.round(info.progress * 100) + '%';
    }

    // ---- navegação ------------------------------------------------------------------
    function go(step) {
      state.step = step;
      var idx = ORDER.indexOf(step);
      if (idx > state.reached) state.reached = idx;
      els.panels.forEach(function (p) { p.hidden = p.getAttribute('data-step') !== step; });
      els.dots.forEach(function (dot) {
        var i = ORDER.indexOf(dot.getAttribute('data-step-dot'));
        var clickable = i !== idx && i <= state.reached && (i === 0 || state.model);
        dot.classList.toggle('is-active', i === idx);
        dot.classList.toggle('is-done', i < idx || (TYPES.indexOf(ORDER[i]) !== -1 && !!state.chosen[ORDER[i]]));
        dot.classList.toggle('is-clickable', !!clickable);
        if (clickable) {
          dot.setAttribute('role', 'button');
          dot.setAttribute('tabindex', '0');
        } else {
          dot.removeAttribute('role');
          dot.removeAttribute('tabindex');
        }
        if (i === idx) dot.setAttribute('aria-current', 'step');
        else dot.removeAttribute('aria-current');
        renderDot(dot);
      });
      centerActiveStep(modal.querySelector('.yv-p360k__steps'));
      modal.querySelectorAll('[data-p360k-model-label]').forEach(function (n) {
        n.textContent = state.model ? 'Celular: ' + state.model : '';
      });
      // rodapé
      var isType = TYPES.indexOf(step) !== -1;
      els.back.hidden = step === 'model';
      els.skip.hidden = !isType;
      els.skip.textContent = isType && state.chosen[step] ? 'Continuar' : 'Não quero';
      els.finish.hidden = step !== 'summary';
      els.error.hidden = true;
      renderBar();
      els.body.scrollTop = 0;
      if (isType) loadStep(step);
      if (step === 'summary') renderSummary();
      saveState(false);
    }

    // Faixa de etapas: rola para deixar a etapa atual no centro (quando não cabe tudo na tela).
    // Enquanto o modal está abrindo, posiciona sem animação: rolagem suave durante a transição
    // faz o Safari do iPhone demorar a desenhar o cabeçalho.
    function centerActiveStep(list) {
      if (!list) return;
      var active = list.querySelector('[data-step-dot].is-active');
      if (!active) return;
      requestAnimationFrame(function () {
        var max = list.scrollWidth - list.clientWidth;
        if (max <= 0) return;
        var left = Math.max(0, Math.min(max, active.offsetLeft - (list.clientWidth - active.offsetWidth) / 2));
        if (opening) list.scrollLeft = left;
        else list.scrollTo({ left: left, behavior: 'smooth' });
      });
      // miniaturas mudam a largura ao carregar: recentraliza
      list.querySelectorAll('img').forEach(function (img) {
        if (!img.complete) img.addEventListener('load', function () { centerActiveStep(list); }, { once: true });
      });
    }

    // Etapa com escolha: Celular mostra o modelo; Capa/Película/Câmera mostram a miniatura do produto
    function renderDot(dot) {
      var key = dot.getAttribute('data-step-dot');
      var num = dot.querySelector('.yv-p360k__step-num');
      var name = dot.querySelector('.yv-p360k__step-name');
      if (!dot.hasAttribute('data-name')) dot.setAttribute('data-name', name.textContent);
      if (!num.hasAttribute('data-num')) num.setAttribute('data-num', num.textContent);
      var baseName = dot.getAttribute('data-name');
      var it = TYPES.indexOf(key) !== -1 ? state.chosen[key] : null;

      num.innerHTML = '';
      dot.classList.remove('has-thumb', 'has-value');
      dot.removeAttribute('title');
      if (key === 'model' && state.model) {
        name.textContent = state.model;
        num.textContent = num.getAttribute('data-num');
        dot.classList.add('has-value');
        dot.setAttribute('title', 'Celular: ' + state.model);
      } else if (it) {
        name.textContent = baseName;
        if (it.img) {
          var img = el('img');
          img.src = it.img;
          img.alt = '';
          img.width = 100;
          img.height = 100;
          num.appendChild(img);
          dot.classList.add('has-thumb');
        } else {
          num.textContent = '✓';
        }
        dot.classList.add('has-value');
        dot.setAttribute('title', baseName + ': ' + it.title + (it.variantTitle ? ' — ' + it.variantTitle : ''));
      } else {
        name.textContent = baseName;
        num.textContent = num.getAttribute('data-num');
      }
    }

    function next() {
      go(ORDER[Math.min(ORDER.length - 1, ORDER.indexOf(state.step) + 1)]);
    }
    function prev() {
      go(ORDER[Math.max(0, ORDER.indexOf(state.step) - 1)]);
    }

    // ---- resultados -----------------------------------------------------------------
    function buildUrl(type, page) {
      var q = [
        'view=protecao-360',
        'section_id=protecao-360-results',
        'filter.p.product_type=' + encodeURIComponent(cfg.types[type]),
        'page=' + page
      ];
      if (state.linha) q.push('filter.p.m.custom.linha_do_smartphone=' + encodeURIComponent(state.linha));
      return cfg.resultsUrl + '?' + q.join('&');
    }

    function fetchAll(type) {
      var key = state.linha + '|' + cfg.types[type];
      if (cache[key]) return cache[key];
      var cards = [];
      function page(n) {
        return fetch(buildUrl(type, n), { credentials: 'same-origin' })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var wrap = doc.querySelector('[data-p360-results]');
            if (!wrap) return;
            wrap.querySelectorAll('.yv-p360-card').forEach(function (c) { cards.push(c); });
            var total = parseInt(wrap.getAttribute('data-total-pages'), 10) || 1;
            if (n < total && n < MAX_PAGES) return page(n + 1);
          });
      }
      cache[key] = page(1).then(function () { return cards; }, function (err) {
        delete cache[key];
        throw err;
      });
      return cache[key];
    }

    function prepCard(card) {
      // bolinhas de cor e select de opções acima do botão "Escolher"
      var action = card.querySelector('.yv-external-cta__action');
      if (action) {
        ['.color-variants-wrapper', '.yv-p360-card__variant-wrap'].forEach(function (sel) {
          var n = card.querySelector(sel);
          if (n) action.parentNode.insertBefore(n, action);
        });
      }
    }

    function markSelected(card, variantId) {
      var sel = card.querySelector('[data-p360-variant]');
      if (!sel) return;
      for (var i = 0; i < sel.options.length; i++) {
        if (String(sel.options[i].value) === String(variantId)) {
          sel.selectedIndex = i;
          card.classList.add('is-selected');
          var label = card.querySelector('[data-p360-pick-label]');
          if (label) label.textContent = 'Escolhido ✓';
          return true;
        }
      }
      return false;
    }

    function loadStep(type) {
      var p = modal.querySelector('[data-step="' + type + '"]');
      var grid = p.querySelector('[data-p360k-grid]');
      var empty = p.querySelector('[data-p360k-empty]');
      grid.innerHTML = '';
      empty.hidden = true;
      els.loading.hidden = false;
      var model = state.model.trim().toLowerCase();
      fetchAll(type).then(function (cards) {
        if (state.step !== type) return;
        var matches = cards.filter(function (c) {
          return cardFits(c, model);
        });
        var cur = state.chosen[type];
        var first = null;
        matches.forEach(function (c) {
          var card = c.cloneNode(true);
          prepCard(card);
          if (cur && markSelected(card, cur.variantId)) first = card;
          grid.appendChild(card);
        });
        // escolhido primeiro na lista
        if (first) grid.insertBefore(first, grid.firstChild);
        empty.textContent = 'Não encontramos opções desta categoria para o seu modelo.';
        empty.hidden = matches.length > 0;
      }).catch(function () {
        empty.textContent = 'Não foi possível carregar as opções. Tente novamente.';
        empty.hidden = false;
      }).then(function () { els.loading.hidden = true; });
    }

    // ---- resumo ---------------------------------------------------------------------
    function renderSummary() {
      var disc = discountInfo();
      var list = modal.querySelector('[data-p360k-summary]');
      var totals = modal.querySelector('[data-p360k-totals]');
      list.innerHTML = '';
      var subtotal = 0;
      TYPES.forEach(function (t) {
        var it = state.chosen[t];
        var li = el('li', 'yv-p360k__item' + (it ? '' : ' is-empty'));
        if (it && it.img) {
          var img = el('img');
          img.src = it.img;
          img.alt = '';
          img.width = 72;
          img.height = 72;
          img.loading = 'lazy';
          li.appendChild(img);
        } else {
          li.appendChild(el('span', 'yv-p360k__item-ph'));
        }
        var info = el('div', 'yv-p360k__item-info');
        info.appendChild(el('small', null, LABELS[t]));
        if (it) {
          subtotal += it.cents;
          info.appendChild(el('strong', null, it.title));
          if (it.variantTitle) info.appendChild(el('span', 'yv-p360k__item-variant', it.variantTitle));
          var lineOff = disc.lineOff && disc.lineOff[t];
          if (lineOff) {
            // como no carrinho: preço riscado, preço com desconto e o nome do desconto
            var pr = el('span', 'yv-p360k__item-price');
            pr.appendChild(el('s', 'yv-p360k__item-was', money(it.cents)));
            pr.appendChild(document.createTextNode(' ' + money(it.cents - lineOff)));
            info.appendChild(pr);
            info.appendChild(el('span', 'yv-p360k__item-disc', disc.title + ' (-' + money(lineOff) + ')'));
          } else {
            info.appendChild(el('span', 'yv-p360k__item-price', money(it.cents)));
          }
        } else {
          info.appendChild(el('span', 'yv-p360k__item-none', 'Não incluído'));
        }
        li.appendChild(info);
        var actions = el('div', 'yv-p360k__item-actions');
        var change = el('button', 'yv-p360k-link', it ? 'Trocar' : 'Escolher');
        change.type = 'button';
        change.setAttribute('data-p360k-goto', t);
        actions.appendChild(change);
        if (it) {
          var remove = el('button', 'yv-p360k-link yv-p360k-link--muted', 'Remover');
          remove.type = 'button';
          remove.setAttribute('data-p360k-remove', t);
          actions.appendChild(remove);
        }
        li.appendChild(actions);
        list.appendChild(li);
      });

      var info = discountInfo();
      if (info.gift && cfg.discount.giftVariantId) {
        var gift = el('li', 'yv-p360k__item yv-p360k__item--gift');
        gift.appendChild(el('span', 'yv-p360k__item-ph'));
        var gi = el('div', 'yv-p360k__item-info');
        gi.appendChild(el('small', null, 'Brinde'));
        gi.appendChild(el('strong', null, cfg.discount.giftText || 'Brinde'));
        gi.appendChild(el('span', 'yv-p360k__item-price', 'Grátis'));
        gift.appendChild(gi);
        list.appendChild(gift);
      }

      totals.innerHTML = '';
      function row(label, value, cls) {
        var r = el('div', cls || '');
        r.appendChild(el('span', null, label));
        r.appendChild(el('span', null, value));
        totals.appendChild(r);
      }
      var off = 0;
      var offLabel = '';
      if (info.lineOff) {
        Object.keys(info.lineOff).forEach(function (k) { off += info.lineOff[k]; });
        offLabel = 'Desconto ' + info.title;
      } else if (info.pct) {
        off = Math.round((subtotal * info.pct) / 100);
        offLabel = 'Desconto do kit (' + info.pct + '%)';
      }
      row('Subtotal', money(subtotal));
      if (off) row(offLabel, '- ' + money(off), 'is-off');
      row('Total', money(subtotal - off), 'is-total');
      if (info.configured && info.message) totals.appendChild(el('p', 'yv-p360k__totals-msg', info.message));

      els.finish.disabled = chosenCount() === 0;
    }

    // ---- carrinho -------------------------------------------------------------------
    function setBusy(on) {
      busy = on;
      els.loading.hidden = !on;
      [els.finish, els.back].forEach(function (b) { b.disabled = on; });
    }

    function finish() {
      if (busy) return;
      var info = discountInfo();
      var items = [];
      TYPES.forEach(function (t) {
        var it = state.chosen[t];
        if (it) items.push({ id: it.variantId, quantity: 1, properties: { _yv_p360: kitId } });
      });
      if (!items.length) {
        els.error.textContent = 'Escolha ao menos um item para continuar.';
        els.error.hidden = false;
        return;
      }
      if (info.gift && cfg.discount.giftVariantId) {
        items.push({ id: cfg.discount.giftVariantId, quantity: 1, properties: { _yv_p360: kitId, _yv_p360_gift: '1' } });
      }
      setBusy(true);
      els.error.hidden = true;
      fetch(cfg.cartAddUrl + '.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok) throw new Error(j.description || j.message || 'Erro ao adicionar ao carrinho');
        });
      }).then(function () {
        // Mesmo caminho da seção: drawer do tema via gatilho .openCartDrawer; sem drawer, página do carrinho
        var opener = document.querySelector('.openCartDrawer');
        var drawerOn = typeof cartDrawerEnable !== 'undefined' && cartDrawerEnable && !!opener;
        if (!drawerOn) {
          window.location.href = info.code
            ? '/discount/' + encodeURIComponent(info.code) + '?redirect=' + encodeURIComponent(cfg.cartUrl)
            : cfg.cartUrl;
          return;
        }
        var applyCode = info.code
          ? fetch('/cart/update.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ discount: info.code })
            }).catch(function () {})
          : Promise.resolve();
        return applyCode.then(function () {
          setBusy(false);
          close();
          clearState();
          reset();
          opener.click();
        });
      }).catch(function (err) {
        els.error.textContent = err.message || 'Não foi possível adicionar ao carrinho.';
        els.error.hidden = false;
        setBusy(false);
      });
    }

    // ---- abrir / fechar ---------------------------------------------------------------
    var opening = false;

    function open() {
      reset();
      var ctx = cfg.context || {};
      var startStep = 'model';
      var saved = loadState();
      if (saved) {
        // continua de onde parou
        state.model = saved.model || '';
        state.linha = saved.linha || '';
        state.reached = saved.reached || 0;
        state.chosen = {
          case: saved.chosen && saved.chosen.case || null,
          film: saved.chosen && saved.chosen.film || null,
          camera: saved.chosen && saved.chosen.camera || null
        };
        if (saved.kitId) kitId = saved.kitId;
        startStep = saved.step;
      } else if (ctx.model) {
        state.model = ctx.model;
        state.linha = ctx.linha || '';
        var item = ctx.type ? pageItem() : null;
        if (item) state.chosen[ctx.type] = item;
        // abre na primeira etapa ainda sem item (ex.: página da capa -> Película)
        startStep = TYPES.filter(function (t) { return !state.chosen[t]; })[0] || 'summary';
        state.reached = ORDER.indexOf(startStep);
      }
      lastFocus = document.activeElement;
      opening = true;
      modal.hidden = false;
      document.documentElement.classList.add('yv-p360k-open');
      go(startStep);
      requestAnimationFrame(function () { modal.classList.add('is-open'); });
      // foco só depois da animação: focar durante a subida faz o Safari rolar/repintar o modal
      setTimeout(function () {
        opening = false;
        var closeBtn = modal.querySelector('.yv-p360k__close');
        if (closeBtn && !modal.hidden) closeBtn.focus({ preventScroll: true });
      }, 320);
    }

    function close() {
      modal.classList.remove('is-open');
      document.documentElement.classList.remove('yv-p360k-open');
      setTimeout(function () { modal.hidden = true; }, 250);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    // ---- eventos --------------------------------------------------------------------
    root.querySelector('[data-p360k-open]').addEventListener('click', open);
    window.addEventListener('resize', function () {
      if (!modal.hidden) centerActiveStep(modal.querySelector('.yv-p360k__steps'));
    });

    modal.addEventListener('click', function (e) {
      var t = e.target;
      var btn;
      if (t.closest('[data-p360k-close]')) return close();
      if ((btn = t.closest('[data-step-dot].is-clickable'))) return go(btn.getAttribute('data-step-dot'));
      if ((btn = t.closest('[data-p360k-model]'))) {
        var model = btn.getAttribute('data-model');
        if (model !== state.model) {
          state.chosen = { case: null, film: null, camera: null };
          state.reached = 0;
        }
        state.model = model;
        state.linha = btn.getAttribute('data-linha');
        return next();
      }
      if ((btn = t.closest('[data-p360-pick]'))) {
        e.preventDefault();
        var card = btn.closest('.yv-p360-card');
        var sel = card.querySelector('[data-p360-variant]');
        var opt = sel ? sel.options[sel.selectedIndex] : null;
        if (!opt) return;
        var img = card.querySelector('[data-product-grid-main-image] img');
        state.chosen[state.step] = {
          variantId: opt.value,
          title: card.getAttribute('data-title'),
          variantTitle: sel.options.length > 1 ? opt.textContent.trim() : '',
          cents: parseInt(opt.getAttribute('data-cents'), 10) || 0,
          img: opt.getAttribute('data-img') || (img ? img.currentSrc || img.src : '')
        };
        return next();
      }
      if (t.closest('[data-p360k-skip]')) {
        // "Continuar" mantém o item já escolhido; "Não quero" segue sem item
        return next();
      }
      if (t.closest('[data-p360k-back]')) return prev();
      if (t.closest('[data-p360k-finish]')) return finish();
      if ((btn = t.closest('[data-p360k-goto]'))) return go(btn.getAttribute('data-p360k-goto'));
      if ((btn = t.closest('[data-p360k-remove]'))) {
        state.chosen[btn.getAttribute('data-p360k-remove')] = null;
        renderBar();
        go('summary');
        return;
      }
      // imagem ou título do card: vai para a página do produto (mesma aba) e guarda o progresso para retomar na volta
      if (!t.closest('.color-variants-wrapper, button, select')) {
        var card2 = t.closest('.yv-p360-card');
        var link = t.closest('.yv-p360-card a[href]') ||
          (card2 && t.closest('.yv-product-card-img') ? card2.querySelector('.yv-product-img[href], a.yv-product-title[href]') : null);
        if (link) {
          e.preventDefault();
          e.stopPropagation();
          saveState(true);
          window.location.href = link.href;
        }
      }
    });

    modal.addEventListener('change', function (e) {
      var t = e.target;
      var card = t.closest('.yv-p360-card');
      if (!card) return;
      var sel = card.querySelector('[data-p360-variant]');
      if (!sel) return;
      // bolinha de cor (imagem e preço tratados pelo tema): sincroniza a variante
      if (t.matches('.color-variants-wrapper .productOption')) {
        for (var i = 0; i < sel.options.length; i++) {
          if (sel.options[i].getAttribute('data-color') === t.value) {
            sel.selectedIndex = i;
            break;
          }
        }
        return;
      }
      if (t !== sel) return;
      var opt = sel.options[sel.selectedIndex];
      var cents = Number(opt.getAttribute('data-cents'));
      var compare = Number(opt.getAttribute('data-compare'));
      card.querySelectorAll('[data-yv-price-box]').forEach(function (box) {
        var pix = Number(box.getAttribute('data-yv-pix')) || 0;
        var price = box.querySelector('[data-yv-price-value]');
        if (price) price.textContent = money(Math.floor(cents * (100 - pix) / 100));
        box.querySelectorAll('[data-yv-bonus-value]').forEach(function (value) {
          value.textContent = money(Math.round(cents * Number(value.dataset.yvBonusPercent) / 100));
        });
        var was = box.querySelector('[data-yv-compare]');
        if (was) {
          was.textContent = compare > cents ? money(compare) : '';
          was.style.display = compare > cents ? '' : 'none';
        }
      });
      card.querySelectorAll('[data-yv-from]').forEach(function (label) { label.style.display = 'none'; });
      card.querySelectorAll('[data-yv-inst]').forEach(function (label) {
        var max = Number(label.getAttribute('data-yv-inst-max')) || 1;
        var min = Number(label.getAttribute('data-yv-inst-min')) || 100;
        var n = Math.min(max, Math.max(1, Math.floor(cents / min)));
        label.textContent = label.getAttribute('data-yv-inst-tpl').replace('{n}', n).replace('{v}', money(Math.floor(cents / n)));
      });
      var src = opt.getAttribute('data-img');
      var img = card.querySelector('[data-product-grid-main-image] img');
      if (src && img) {
        img.removeAttribute('srcset');
        img.src = src;
      }
    });

    modal.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') return close();
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var dot = e.target.closest && e.target.closest('[data-step-dot].is-clickable');
      if (!dot) return;
      e.preventDefault();
      go(dot.getAttribute('data-step-dot'));
    });

    reset();

    var pending = loadState();
    if (pending && pending.resume) open();
    // voltar pelo histórico com a página em cache (bfcache): mantém o modal como estava
    window.addEventListener('pageshow', function (ev) {
      if (!ev.persisted) return;
      var again = loadState();
      if (again && again.resume && modal.hidden) open();
      else if (again && again.resume) saveState(false);
    });
  }

  function boot() {
    document.querySelectorAll('[data-p360-kit]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:block:select', boot);
})();
